import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui/IconButton'
import { type IRowDefault } from 'shared/ui/TableNew'

type IExpandCellProps<TRow> = {
  row: TRow
}

export const ExpandCell = observer(<TRow extends IRowDefault>({ row }: IExpandCellProps<TRow>) => {
  if (row.is_can_expanded) {
    return (
      <IconButton
        size={'large'}
        icon={row.expanded ? 'chevronDown' : 'chevronRight'}
        color={'transparent'}
        variant={'icon'}
        transparentBackground
        transparentInactive
        fontSize={16}
        onClick={row.toggleExpand}
        ariaLabel='ExpandCall'
      />
    )
  }
  return null
})
